import { Component, OnInit, Input } from '@angular/core';
import { MainComponent } from 'src/app/main/main.component';

@Component({
  selector: 'new-alert-notification',
  templateUrl: './new-alert-notification.component.html'
})
export class NewAlertNotificationComponent implements OnInit {
  @Input() alertNotification: any;

  interval: any;
  constructor(
    private main: MainComponent
  ) { }

  ngOnInit() {
    this.interval = setInterval(()=> { this.closeAlertNotification(this.alertNotification.id); clearInterval(this.interval) }, 60000)
  }

  closeAlertNotification(id){
    this.main.closeAlertNotificationBanner(id)
  }
}
